module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "Loading"
    }
  }, [_c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(_vm.loading) ? _c('div', {
    staticClass: "col-xs-2 csp-loading"
  }, [_c('i', {
    staticClass: "fa fa-circle-o-notch fa-spin fa-2"
  }), _vm._v(" "), _c('span', {
    staticClass: "sr-only"
  }, [_vm._v("Loading...")])]) : _vm._e()])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-3b38506c!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Loading.vue
// module id = 857
// module chunks = 2